import { Component } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { CrudComponent } from "src/app/components/shared/cruds/crud.component";
import { Condition } from "src/app/models/custom-types";
import { AlertaDTO } from "src/app/models/dto/alerta.dto";
import { FilterEvent } from "src/app/models/filter";
import { ListAction } from "src/app/models/list-actions.model";
import { ListColumn } from "src/app/models/list-columns.model";
import { AlertasSwalService } from "src/app/services/alerts.service";
import { LayoutsService } from "src/app/services/layouts.service";
import { Filter } from "src/app/shared/classes/filter";
import { AlertasService } from "./alertas.service";
import { AlertaProgramadasModal } from "./modal-programadas/modal.component";

@Component({
  selector: "app-alertas",
  templateUrl: "./alertas.component.html",
  styles: [],
})
export class AlertasComponent extends CrudComponent<AlertaDTO> {
  columnId: string = "IdEmpresa";
  public columns: ListColumn[] = [
    {
      name: "Descripcion",
      property: "Descripcion",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Correos",
      property: "Correos",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Periodo",
      property: "Periodo",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "CreadoPor",
      property: "CreadoPor",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Pendientes",
      property: "Pendientes",
      visible: true,
      isModelProperty: true,
    },
    {
      name: "Enviadas",
      property: "Enviadas",
      visible: true,
      isModelProperty: true,
    },
    {
      name: "actions",
      property: "actions",
      visible: true,
      isModelProperty: false,
    },
  ];

  public actions: ListAction<any>[] = [
    {
      desc: "Ver programadas",
      action: "see",
      visible: () => true,
    },
    {
      desc: "Actualizar",
      action: "update",
      visible: (row) => row[this.columnActive],
    },
    {
      desc: "Eliminar",
      action: "remove",
      visible: (row) => row[this.columnActive],
    },
  ];
  realdata: AlertaDTO[];
  constructor(
    public service: AlertasService,
    public layoutService: LayoutsService,
    public dialog: MatDialog,
    public alerts: AlertasSwalService
  ) {
    super(service, alerts);
    this.filter = new Filter<AlertaDTO>(this.conditions, this.columns, true);
  }

  loadRecords() {
    this.service.get().subscribe(
      (resultData) => {
        this.realdata = resultData;
        this.filter.setDataTable(this.realdata, this.tableComp);
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      }
    );
  }

  //#region Filter

  public filter: Filter<AlertaDTO>;
  public conditions: Condition<AlertaDTO> = {
    Descripcion: (o, f) =>
      (o.Descripcion ?? "").toLocaleLowerCase().indexOf(f) > -1,
    Correos: (o, f) => (o.Correos ?? "").toLocaleLowerCase().indexOf(f) > -1,
    Periodo: (o, f) => (o.Periodo ?? "").toLocaleLowerCase().indexOf(f) > -1,
    CreadoPor: (o, f) =>
      (o.CreadoPor ?? "").toLocaleLowerCase().indexOf(f) > -1,
  };

  filterdata(e: FilterEvent) {
    this.filter.filterdata(e, this.realdata, this.tableComp);
  }

  //#endregion Filter

  actionstable(e: { action: string; row: any }) {
    if (e.action == "update") {
      this.formulario.setUpdate(e.row);
    } else if (e.action == "see") {
      this.opendialoghistorial(e.row.IdAlertasRegistro);
    } else if (e.action == "remove") {
      this.askRemove(e.row);
    }
  }

  async opendialoghistorial(id) {
    await this.dialog
      .open(AlertaProgramadasModal, {
        panelClass: ["modal-for-table", "w-1/4"],
        data: {
          IdAlertasRegistro: id,
        },
      })
      .afterClosed()
      .toPromise();

    this.loadRecords();
  }
}
